<template>
  <div class="search">
    <input type="text" v-model="input" @keyup="searchInput()" :placeholder="placeholder" data-cy="search" />
  </div>
</template>

<script>
export default {
  name: 'SearchInput',

  data() {
    return {
      input: '',
      timeout: null,
      delay: 300,
      emptyText: '-',
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    attributes: {
      type: Array,
      default: () => [],
    },
    entityName: {
      type: String,
      default: 'something',
    },
  },
  computed: {
    placeholder() {
      return `Search for ${this.entityName}`;
    },
  },
  watch: {
    items() {
      this.searchInput();
    },
  },

  mounted() {
    if (!this.attributes) {
      let columns = {};
      for (const o of this.items) {
        const keys = Object.keys(o);
        for (const k of keys) {
          columns[k] = k;
        }
      }
      columns = Object.keys(columns);
      this.attributes = [];
      for (const c of columns) {
        this.attributes.push({ name: c });
      }
    } else {
      for (const a of this.attributes) {
        a.name = a.formatted ? a.formatted : a.name;
      }
    }
  },

  methods: {
    searchInput() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        // If we use the search just for the input (in case of filter on server side)
        this.$emit('input', this.input);

        if (!!this.items && this.items.length > 0) {
          const results = this.search();

          // If we use the search locally
          this.$emit('refresh', results);
        }
      }, this.delay);
    },
    search() {
      let filteredTable = [];

      if (!this.input || this.input.trim().length === 0) {
        filteredTable = this.items;
      } else {
        const filters = this.formatItem(this.input).toLowerCase().trim().split(' ');

        // When the search field is empty, the table has one empty string
        filteredTable = this.items.filter((p) => {
          // For all the this.attributes of the object
          for (const a of this.attributes) {
            // Continue if the value is not null
            if (this.getProperty(p, a.name) != null) {
              // Check all the filter to see if it matches at least one
              for (const filter of filters) {
                // If the value is not a number
                if (
                  isNaN(+this.getProperty(p, a.name)) &&
                  this.formatItem(String(this.getProperty(p, a.name)))
                    .toLowerCase()
                    .includes(filter)
                ) {
                  return true;

                  // If the value and the filter are numbers
                } else if (
                  !isNaN(+this.getProperty(p, a.name)) &&
                  !isNaN(+filter) &&
                  +this.getProperty(p, a.name) === +filter
                ) {
                  return true;
                }
              }
            }
          }

          return false;
        });
      }

      return filteredTable;
    },
    formatItem(item) {
      return item.toLowerCase().replace(/[àâ]/g, 'a').replace(/[éèê]/g, 'e');
    },
    getProperty(item, properyPath) {
      if (!properyPath.includes('.')) {
        if (item[properyPath] !== null) return item[properyPath];
        else return this.emptyText;
      }

      const props = properyPath.split('.');

      let data;
      let acc = item;
      for (let i = 0; i < props.length; i++) {
        const prop = props[i];
        if (!acc[prop]) {
          return this.emptyText;
        }
        if (i === props.length - 1) {
          data = acc[prop];
        } else {
          acc = acc[prop];
        }
      }

      return data;
    },
  },
};
</script>